import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2'; // Import SweetAlert2

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_1dn1rrm', 'template_60dxqwa', form.current, {
        publicKey: '5qVbCpzyCM_IyUF4q',  // Replace with your actual public key from EmailJS
      })
      .then(
        () => {
          // Success callback: show SweetAlert
          Swal.fire({
            title: 'Success!',
            text: 'Your message has been sent successfully.',
            icon: 'success',
            showConfirmButton:false,
            timer:3000
            }).then(() => {
            // Reset the form after successful submission
            form.current.reset();
          });
        },
        (error) => {
          // Error callback: show error alert
          console.log('FAILED...', error.text);
          Swal.fire({
            title: 'Oops!',
            text: 'Something went wrong, please try again later.',
            icon: 'error',
            showConfirmButton:false,
            timer:3000
          }).then(() => {
            // Reset the form after error message
            form.current.reset();
          });
        }
      );
  };

  return (
    <div id='Contact'>
      <section 
        className="consultations sec-padd" 
        style={{ backgroundImage: "url(https://st.ourhtmldemo.com/new/experts_html/images/background/5.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-6 col-xs-12">   
              <div className="contact-info">
                <div className="section-title">
                  <h3>Contact Details</h3>
                </div>
                <div className="text">
                  <p style={{marginBottom:'34px'}}>Please find below contact details <br />and contact us today!</p>
                </div>
                <div className="widget-content">
                  <ul className="list-info">
                    {/* <li><span className="fa fa-phone"></span>Phone: +321 456 78 901</li> */}
                    <li className='mb-4'><span className="fa fa-envelope"></span>Email: info@sahainfotechs.com</li>
                    <li className='mb-4'><span className="fa fa-clock"></span>Mon to Sat: 9.00am to 4.00pm</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-sm-12 col-xs-12">
              <div className="section-title">
                <h2>Request For Call Back</h2>
              </div>
              <div className="default-form-area">
                <form 
                  id="contact_form" 
                  name="contact_form" 
                  className="default-form" 
                  ref={form} 
                  onSubmit={sendEmail}
                >
                  <div className="row clearfix">
                    <div className="col-md-4 col-sm-6 col-xs-12 column">
                      <div className="form-group">
                        <input 
                          type="text" 
                          name="from_name" 
                          className="form-control" 
                          placeholder="Name *" 
                          required 
                        />
                      </div>
                      <div className="form-group">
                        <input 
                          type="email" 
                          name="email" 
                          className="form-control required email" 
                          placeholder="Email Address *" 
                          required 
                        />
                      </div>
                      <div className="form-group">
                        <input 
                          type="number" 
                          name="phonenumber" 
                          className="form-control" 
                          placeholder="Phone Number*" 
                          required 
                        />
                      </div>
                    </div>
                    <div className="col-md-8 col-sm-6 col-xs-12 column">
                      <div className="form-group style-2">
                        <textarea 
                          name="message" 
                          className="form-control textarea required" 
                          placeholder="Special Request..."
                        />
                        <input 
                          id="form_botcheck" 
                          name="form_botcheck" 
                          className="form-control" 
                          type="hidden" 
                          value="" 
                        />
                        <button 
                          className="thm-btn thm-color" 
                          type="submit" 
                          data-loading-text="Please wait..."
                        >
                          <i className="fa fa-paper-plane"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
